import React from 'react';

const ProgressHeader = ({ label, step }) => {
  return (
	<div className="py-2">
	  {label && <h4>{label}</h4>}
	  <div style={{ backgroundColor: '#eee', height: 6, borderRadius: 3 }}>
		<div
		  style={{
			width: step === 1 ? '50%' : '100%',
			backgroundColor: '#6c4cc4',
			height: 6,
			borderRadius: 3,
			transition: 'width 0.3s ease-in-out',
		  }}
		/>
	  </div>
	</div>
  );
};

export default ProgressHeader;
